<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="login subscribe active maintenance">
			<div class="w-100 text-center">
				<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			</div>
			<div class="heading">
				<h1>Site en maintenance</h1>
				<p>Le site est actuellement en maintenance. <br>Merci de bien vouloir vous reconnecter ultérieurement.
					<br><br> A très bientôt sur Patrimoffice.</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Maintenance'
}
</script>



// WEBPACK FOOTER //
// src/views/Errors/Maintenance.vue